import { actions } from "./actions";
import { mutations } from "./mutations";
const state = {
  data: {},
  fieldInfoList:[],
  fieldTable: {},
  codeEnum: [],
  fieldCodeEnumList: []
};

export default {
  state,
  actions,
  mutations
};
